import React, { createContext, useContext, useState, ReactNode, useMemo, useCallback } from 'react';
import { ITask } from '../interface/tasks';

interface TaskContextType {
  task: ITask | null;
  initialTask: ITask | null;
  updateTask: (task: ITask | null) => void;
  clearInitialTask: () => void;
}

const TaskContext = createContext<TaskContextType | undefined>(undefined);

export const TaskProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [task, setTask] = useState<ITask | null>(null);
  const [initialTask, setInitialTask] = useState<ITask | null>(null);

  const updateTask = useCallback((data: ITask | null) => {
    if (data) {
      setInitialTask((currentInitialTask) => currentInitialTask ?? data);
    }
    setTask(data);
  }, []);
  const clearInitialTask = useCallback(() => {
    setInitialTask(null);
  }, []);
  const taskContextValue = useMemo(
    () => ({ task, updateTask, initialTask, clearInitialTask }),
    [task, updateTask, initialTask, clearInitialTask],
  );
  return <TaskContext.Provider value={taskContextValue}>{children}</TaskContext.Provider>;
};

export const useTask = () => {
  const context = useContext(TaskContext);
  if (!context) {
    throw new Error('useTask must be used within a TaskProvider');
  }
  return context;
};
